<template>
  <div>
    <b style="font-size: 13px"
      >Total Tasks For Each Designer <br />
      From {{ listDate[0] }} to
      {{ listDate[listDate.length - 1] }}
    </b>
    <div class="tbl-scroll">
      <table
        class="table"
        v-if="data.length > 0"
        style="text-align: left; margin-left: 10px; font-size: 14px"
      >
        <thead class="thead-light">
          <tr>
            <th>Designer</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) of data" :key="index">
            <td>{{ item.designer }}</td>
            <td>{{ item.total }}</td>
          </tr>
        </tbody>

        <tbody></tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataTask: Object,
    listDate: Array,
    listDesigner: Array,
  },
  data: () => ({
    data: [],
  }),
  methods: {
    convertData() {
      for (const designer of this.listDesigner) {
        var data = {
          designer: designer,
          total: 0,
        };
        for (const date of this.listDate) {
          //console.log("task: ", this.dataTask[date]);
          data.total += this.dataTask[date][designer];
        }
        this.data.push(data);
      }

      console.log("this.data Total: ", this.data);
    },
  },
  mounted() {
    //console.log("dataTask: ", this.dataTask);
    //console.log("listDate: ", this.listDate);
    //console.log("listDesigner: ", this.listDesigner);
    this.convertData();
  },
};
</script>

<style scoped>
.tbl-scroll {
  height: 50vh;
  overflow: auto;
}
</style>